// extracted by mini-css-extract-plugin
module.exports = {"titre":"galerie-module--titre--2vBMc","button":"galerie-module--button--32aKL","contenu":"galerie-module--contenu--IwNOm","lettre":"galerie-module--lettre--3nDBs"};